<div class="card mt-3">
    <div class="card-body">

        <div class="row mt-4 align-items-center">
            <div class="col-md-6">
                <h4>All Notes</h4>
            </div>
            <div class="col-md-6">
                <div class="float-right">
                    <div class="d-inline align-middle mx-3 text-secondary" (click)="printSection('printable-section')">
                        <mat-icon>print</mat-icon>
                        <div class="print-txt">Print</div>
                    </div>
                    <p-button (onClick)="showDialog()">ADD NOTES</p-button>
                </div>
            </div>
        </div> 

        <div class="mt-4">
            <h6>Notes related to Individuals</h6>
            <mat-accordion [togglePosition]="'before'">
                <mat-expansion-panel [expanded]="isPanelExpanded">
                    <mat-expansion-panel-header>
                        <div class="w-100 row">
                            <div class="col-md-12 acc-title-text">
                              Beneficiary General Notes    
                            </div>
                        </div>
                    </mat-expansion-panel-header>
                    <div class="p-3">
                        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" *ngIf="totalGeneralRecord > 0">
                            <!-- Checkbox Column -->
                            <ng-container matColumnDef="select">
                                <th mat-header-cell *matHeaderCellDef>
                                    <mat-checkbox (change)="$event ? masterToggle() : null"
                                        [checked]="selectionGeneralNotes.hasValue() && isAllSelected()"
                                        [indeterminate]="selectionGeneralNotes.hasValue() && !isAllSelected()">
                                    </mat-checkbox>
                                </th>
                                <td mat-cell *matCellDef="let row">
                                    <mat-checkbox (click)="$event.stopPropagation()"
                                        (change)="$event ? selectionGeneralNotes.toggle(row) : null"
                                        [checked]="selectionGeneralNotes.isSelected(row)">
                                    </mat-checkbox>
                                </td>
                            </ng-container>

                            <!-- Description Column -->
                            <ng-container matColumnDef="noteText">
                              <th mat-header-cell *matHeaderCellDef>
                                Description
                                <button pTooltip="{{ isGeneralNotesExpanded ? 'Collapse Notes Descriptions' : 'Expand Notes Descriptions' }}"
                                  mat-icon-button tooltipPosition="bottom" (click)="toggleAllGeneralNotes(isGeneralNotesExpanded)">
                                  <mat-icon>{{ isGeneralNotesExpanded ? 'remove_circle_outline' : 'add_circle_outline' }}</mat-icon>
                                </button>
                              </th>
                              <td mat-cell *matCellDef="let element; let i = index;">
                                <ng-container>
                                  {{ element.show ? element.noteText : (element.noteText | slice:0:75) }}
                                  <a [routerLink]="" *ngIf="element.noteText.length > 150;"
                                    (click)="element.show = !element.show; $event.stopPropagation();">
                                    {{ ((element.show)) ? 'Show less' : 'Show more' }}
                                  </a>
                                </ng-container>
                              </td>
                            </ng-container>

                            <!-- Created By Column -->
                            <ng-container matColumnDef="lastUpdatedBy">
                                <th mat-header-cell *matHeaderCellDef> Created By </th>
                                <td mat-cell *matCellDef="let element"> {{element.lastUpdatedBy}} </td>
                            </ng-container>

                            <!-- Created On Column -->
                            <ng-container matColumnDef="lastUpdatedTime">
                                <th mat-header-cell *matHeaderCellDef> Created On </th>
                                <td mat-cell *matCellDef="let element"> {{formatDate(element.lastUpdatedTime)}} </td>
                            </ng-container>

                            <!-- Action Column -->
                            <ng-container matColumnDef="id">
                              <th mat-header-cell *matHeaderCellDef> Action </th>
                              <td mat-cell *matCellDef="let element">
                                <button type="button" class="btn btn-sm p-0 bg-transparent action-btn" [disabled]="element.userID != currentUserId"
                                  (click)="editNotes(element); $event.stopPropagation();">
                                  <i class="fa fa-pencil action-icon" aria-hidden="true" title="Edit"></i>
                                </button>
                                <button type="button" class="btn btn-sm p-0 bg-transparent action-btn" [disabled]="element.userID != currentUserId"
                                  (click)="deleteNotes(element, 'beneficiary'); $event.stopPropagation();">
                                  <i class="fa fa-trash-o action-icon" aria-hidden="true" title="Delete"></i>
                                </button>
                              </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumnsGeneral"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumnsGeneral;"
                                (click)="selectionGeneralNotes.toggle(row)">
                            </tr>
                        </table>
                        <div class="no-data" *ngIf="totalGeneralRecord === 0">
                          <h6>No Data Found!</h6>
                      </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>            
        </div>

        <div class="mt-5">
          <h6>Notes related to Petition</h6>
          <div class="mb-4" *ngFor="let key of getKeys(benePetitionNotes)">
              <mat-accordion [togglePosition]="'before'">
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <div class="w-100 row">
                      <ng-container *ngIf="benePetitionNotes[key]?.length">
                        <div class="col-md-4 acc-title-text">Task ID - {{ benePetitionNotes[key][0].superTaskId }}</div>                      
                        <div class="col-md-4 acc-title-text">{{ benePetitionNotes[key][0].visType }}</div>
                        <div class="col-md-4 acc-title-text">{{ benePetitionNotes[key][0].petitionType }}</div>
                      </ng-container>
                    </div>
                  </mat-expansion-panel-header>
                  <div class="p-3">

                    <table mat-table [dataSource]="benePetitionNotes[key]" class="mat-elevation-z8" *ngIf="benePetitionNotes[key]?.length > 0">                   

                       <!-- Checkbox Column -->
                      <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef>
                          <mat-checkbox (change)="$event ? masterTogglePetition(key) : null"
                            [checked]="getSelectionModelForKey(key).hasValue() && isAllSelectedPetition(key)"
                            [indeterminate]="getSelectionModelForKey(key).hasValue() && !isAllSelectedPetition(key)">
                          </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let row">
                          <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? getSelectionModelForKey(key).toggle(row) : null"
                            [checked]="getSelectionModelForKey(key).isSelected(row)">
                          </mat-checkbox>
                        </td>
                      </ng-container>
            
                      <!-- Description Column -->
                      <ng-container matColumnDef="noteText">
                        <th mat-header-cell *matHeaderCellDef>
                          Description
                          <button mat-icon-button
                            pTooltip="{{ isPetitionNotesExpanded ? 'Collapse Notes Descriptions' : 'Expand Notes Descriptions' }}"
                              tooltipPosition="bottom" (click)="toggleAllPetitionNotes(key)">
                            <mat-icon>{{ isPetitionNotesExpanded ? 'remove_circle_outline' : 'add_circle_outline' }}</mat-icon>
                          </button>
                        </th>
                        <td mat-cell *matCellDef="let note; let i = index;">
                          <ng-container>
                            {{ note.show ? note.noteText : (note.noteText | slice:0:75) }}
                            <a [routerLink]="" *ngIf="note.noteText.length > 150;"
                              (click)="note.show = !note.show; $event.stopPropagation();">
                              {{ ((note.show)) ? 'Show less' : 'Show more' }}
                            </a>
                          </ng-container>
                        </td>
                      </ng-container>
            
                      <!-- Step Name Column -->
                      <ng-container matColumnDef="timelineSteps">
                        <th mat-header-cell *matHeaderCellDef> Step Name </th>
                        <td mat-cell *matCellDef="let note"> {{note.timelineSteps}} </td>
                      </ng-container>
            
                      <!-- Created By Column -->
                      <ng-container matColumnDef="lastUpdatedBy">
                        <th mat-header-cell *matHeaderCellDef> Created By </th>
                        <td mat-cell *matCellDef="let note"> {{note.lastUpdatedBy}} </td>
                      </ng-container>
            
                      <!-- Created On Column -->
                      <ng-container matColumnDef="lastUpdatedTime">
                        <th mat-header-cell *matHeaderCellDef> Created On </th>
                        <td mat-cell *matCellDef="let note"> {{formatDate(note.lastUpdatedTime)}} </td>
                      </ng-container>
            
                      <!-- Action Column -->
                      <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef> Action </th>
                        <td mat-cell *matCellDef="let note">
                          <button type="button" class="btn btn-sm p-0 bg-transparent" [disabled]="note.userID != currentUserId"
                            (click)="deleteNotes(note, 'petition', key); $event.stopPropagation();">
                            <i class="fa fa-trash-o action-icon" aria-hidden="true" title="Delete"></i>
                          </button>
                        </td>
                      </ng-container>
            
                      <!-- Header and Row Definitions -->
                      <tr mat-header-row *matHeaderRowDef="displayedColumnsPetition"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumnsPetition;"></tr>
                    </table>

                    <div class="no-data" *ngIf="benePetitionNotes[key]?.length === 0">
                      <h6>No Data Found!</h6>
                    </div>
                    
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>            
      </div>       
    </div>
</div>




<!-- Confirm Delete Modal -->
<p-confirmDialog id="delete-note-modal" [style]="{width: '35vw'}"></p-confirmDialog>

<!-- Add Notes Modal -->
<p-dialog id="add-notes-modal" [header]="isEditMode ? 'Edit Notes' : 'Add Notes'"  [modal]="true" [(visible)]="showAddNotesModal"
    [style]="{ width: '50rem' }">
    <form #noteForm="ngForm" (ngSubmit)="onSubmit(noteForm)">
        <div class="form-group mt-4">
            <label for="note">Note Details</label>
            <textarea class="form-control" id="note" name="note" [(ngModel)]="note" required rows="4"></textarea>
            <div *ngIf="noteForm.submitted && !note">
                <small>Note is required.</small>
            </div>
        </div>
        <hr />
        <div class="float-right">
            <p-button class="btn-cancel mx-2" severity="secondary"
                (onClick)="hideDialog(); noteForm.resetForm();">CANCEL</p-button>
            <p-button [disabled]="noteForm.invalid" type="submit">{{ isEditMode ? 'UPDATE' : 'ADD' }}</p-button>
        </div>
    </form>
</p-dialog>


<div id="printable-section">
  <table border="1" style="width: 100%; border-collapse: collapse;">
      <thead>
          <tr>
              <th>Note Description</th>
              <th>Step Name</th>
              <th>Created By</th>
              <th>Created On</th>
          </tr>
      </thead>
      <tbody>
          <tr *ngFor="let key of mergedNotes">
              <td style="width: 60%;">{{ key.noteText }}</td>
              <td>{{ key.timelineSteps }}</td>
              <td>{{ key.lastUpdatedBy }}</td>
              <td>{{ formatDate(key.lastUpdatedTime) }}</td>
          </tr>
      </tbody>
  </table>
</div>